import ruLocale from 'antd/es/date-picker/locale/ru_RU';
import enLocale from 'antd/es/date-picker/locale/en_US';
import ukLocale from 'antd/es/date-picker/locale/uk_UA';

export const getDateLocale = (language: string) => {
  switch (language) {
    case 'ru':
      return ruLocale;
    case 'uk':
      return ukLocale;
    case 'en':
      return enLocale;
    default:
      return enLocale;
  }
}; 